import CallApi from 'components/common/custom-components/CallApi';
import ReactSelectBoxImageLabel from 'components/common/custom-components/ReactSelectBoxImageLabel';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import ReactSelect from 'react-select';

const useClientSelectBox = () => {
  const getClients = () => CallApi.get('/clients?sort=name', false);
  const { data } = useQuery('clients', getClients, {
    placeholderData: { data: [] }
  });

  const ClientSelectBox = ({
    name = 'client_id',
    className = '',
    isClearable = false,
    isDisabled = false,
    isLoading = false,
    isMulti = false,
    isSearchable = false,
    placeholder = 'Please select a client',
    onChange = client => {},
    value,
    size = 'md'
  }) => {
    const [client, setClient] = useState(null);

    useEffect(() => {
      if (data?.data?.length > 0) {
        setClient(data.data.find(client => client.id == value));
      }
    }, [value]);

    const smSizeStyles = {
      control: provided => ({
        ...provided,
        minHeight: 10
      }),
      dropdownIndicator: provided => ({ ...provided, padding: 1 }),
      clearIndicator: provided => ({ ...provided, padding: 2 }),
      input: provided => ({ ...provided, padding: 0, margin: 0 })
    };

    const getStyles = () => {
      if (size == 'sm') return smSizeStyles;
    };

    return (
      <ReactSelect
        styles={getStyles()}
        placeholder={placeholder}
        options={data.data}
        name={name}
        formatOptionLabel={client => (
          <ReactSelectBoxImageLabel src={client.favicon} title={client.name} />
        )}
        onChange={client => onChange(client)}
        value={client}
        getOptionValue={client => client.id}
        getOptionLabel={client => client.name}
        className={className}
        isClearable={isClearable}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isMulti={isMulti}
        isSearchable={isSearchable}
        classNamePrefix="react-select"
      />
    );
  };

  return ClientSelectBox;
};

export default useClientSelectBox;
